import React from 'react';
import { ArrowIconType } from '../../domains/common/enums';

interface IChevronIcon {
  type: ArrowIconType;
  fill?: string;
}

const ChevronIcon: React.FC<IChevronIcon> = ({
  type,
  fill = 'currentColor',
}) => {
  if (type === ArrowIconType.LEFT) {
    return (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 8.5L3 5L6.5 1.5"
          stroke={fill}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 1.5L7 5L3.5 8.5"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronIcon;
